<template>
    <div id="arrays-one">
      <div v-for="(item, index) in params" class="font-action">
        <!--{{item}}- {{index}}-{{item.name}}-->
        <p v-bind:class="item.pClass">{{item.name}}</p>
      </div>
    </div>
</template>

<script>
    export default {
        name: "ArraysData",
      data: function () {
        return{
          arraysData: [],
          itemData: {
            name: "",
            content: "",
            createTime: null
          },
          params: [
            {name: "每一次努力，都是成长的积累~~~~~~~~", pClass: "p1"},
            {name: "ღ( ´･ᴗ･` )比心~~~~~~~~~~~~~~~", pClass: "p4"},
            {name: "心怀梦想，一路前行。( ⊙ o ⊙ )！~~~~~~~~~~~~~~~", pClass: "p2"},
            {name: "奋斗的人生最美丽。~~~~~~~~~~~~~~~", pClass: "p3"},
            {name: "欢迎来到雪域灰灰的空间~~~~~~~~~~~~~~~", pClass: "p5"}
          ]
        }
      }
    }
</script>

<style scoped>
  div {
    margin: 0;
    padding: 0;
  }
  #arrays-one {
    position: relative;
    display: inline-block;
    margin: auto;
    padding: 0;
    text-align: right;
    overflow: hidden;
    width: 100%;
    height: 100%;
    line-height: 100%;
  }
  #arrays-one .font-action{
    position: relative;
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }
  #arrays-one .font-action .p1{
    position: relative;
    font-size: 1.2em;
    line-height: 1.6em;
    animation: font-action-move 7.5s infinite ;
  }
  #arrays-one .font-action .p2{
    position: relative;
    font-size: 1.2em;
    line-height: 1.6em;
    animation: font-action-move2 8.2s infinite ;
  }
  #arrays-one .font-action .p3{
    position: relative;
    font-size: 1.2em;
    line-height: 1.6em;
    animation: font-action-move2 7.5s infinite ;
  }
  #arrays-one .font-action .p4{
    position: relative;
    font-size: 1.2em;
    line-height: 1.6em;
    animation: font-action-move2 8s infinite ;
  }
  #arrays-one .font-action .p5{
    position: relative;
    font-size: 1.2em;
    line-height: 1.6em;
    animation: font-action-move2 8.5s infinite ;
  }
  /*规定动画*/
  @keyframes font-action-move {
    0% { color: #2fffbb;right: -120%;top: 0}
    10% { color: #ffdc51;right: -70%;top: 25px}
    30% { color: #ff844e;right: 0;top: 0}
    50% { color: #ff68e3;right: 15%;top: 25px}
    65% { color: #ff9b66;right: 40%;top: 0}
    85% { color: #5ff0ff;right: 70%;top: 25px}
    100% { color: #9fc1ff;right: 100%;top: 0}
  }
  @keyframes font-action-move2 {
    0% { color: #2fffbb;right: -110%;top: 0}
    10% { color: #ffdc51;right: -80%;top: 25px}
    30% { color: #ff844e;right: -30%;top: 0}
    50% { color: #ff68e3;right: 30%;top: 25px}
    65% { color: #ff9b66;right: 60%;top: 0}
    85% { color: #5ff0ff;right: 75%;top: 25px}
    100% { color: #9fc1ff;right: 100%;top: 0}
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ArraysData.vue